export default __webpack_public_path__ + "images/info-icon.678916f8.svg";